<template>
  <div>
    <router-view v-if="!isLoading && paymentLink" />
    <loading-page v-else :isFullPage="true" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import LoadingPage from '../components/LoadingPage.vue';

export default {
  name: 'PaymentLinkWrapper',
  metaInfo: {
    title: 'Link de pagamento',
  },
  components: {
    LoadingPage,
  },
  computed: {
    ...mapState('auth', ['token']),
    ...mapState('paymentLink', ['paymentLink', 'isLoading', 'nextRoute']),
    ...mapState('onboardingV2', ['extraQueryRoute', 'onboarding']),
  },
  methods: {
    ...mapActions('auth', ['setToken']),
    ...mapActions('onboardingV2', ['getOnboarding']),
    ...mapActions('paymentLink', ['getPaymentLink', 'setLoading', 'redirect']),
    redirectToOverview() {
      this.redirect({
        name: 'payment-link-overview',
        query: this.$route.query,
      });
      this.setLoading({ loading: false });
    },
  },
  async mounted() {
    this.setLoading({ loading: true });

    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    const {
      paymentLinkId,
      authToken,
      onboardingToken,
    } = this.$route.query;

    await this.setToken({ token: authToken || onboardingToken });
    await this.getPaymentLink({ paymentLinkId });

    this.redirect({
      name: 'payment-link-overview',
      query: this.$route.query,
    });
    this.setLoading({ loading: false });
  },
};
</script>
